import styled from 'styled-components';
import { space } from 'shared';
import Select from 'components/Form/Select';
import { device } from 'styles/device';

export const InternshipSwitcherWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

// Handlungs-Eintrag im Menue (Thomas-Entscheid 18.08., Variante A). Die Trennlinie
// nach oben ist das einzige, was ihn von den Praktika unterscheidet — ohne sie
// liest er sich wie ein weiteres Praktikum namens "Neues Praktikum".
export const RequestInternshipOption = styled.span`
  display: flex;
  align-items: center;
  gap: ${space(6)};
  width: 100%;
  white-space: nowrap;
  font-weight: 700;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin-top: -${space(4)};
  padding-top: ${space(8)};

  &::before {
    content: '+';
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border: 2px solid currentColor;
    border-radius: 50%;
    font-size: 13px;
    line-height: 1;
  }
`;

export const SelectStyled = styled(Select)`
  margin-left: ${space(10)};
  min-width: 300px;
  @media ${device.mobile} {
    margin-top: ${space(10)};
    margin-left: 0px;
    min-width: 200px;
    .select__single-value {
      max-width: 190px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: nowrap;
    }
  }
`;
